import { ReactNode } from "react";
import styles from "./Sidebar.module.scss";
import { Drawer2 } from "@/frontend/shared/ui/Drawer2";

type SidebarProps = {
  isMobile?: boolean;
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
};

export function Sidebar({ isMobile = false, isOpen, onClose, children }: SidebarProps) {
  if (!isMobile) return children;

  return (
    <Drawer2
      className={styles.drawerContent}
      onClose={onClose}
      isOpen={isOpen}
      position="bottom"
      title="Filters"
      onHeaderClick={() => {}}
    >
      {children}
    </Drawer2>
  );
}
